import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import TextSection from '../../components/TextSection';
import CommercialCharges from '../../components/CommercialCharges';
import Form from '../../components/Form';
import NevoBanner from '../../components/NevoBanner';

import styles from './styles.module.scss'
import CommercialChargingBackground from '../../public/assets/images/commercial-charging-background.jpg';


export default function CommercialChargingPage()  {
  return (
    <>
      <Head>
        <title>Commercial Charging | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={CommercialChargingBackground.src} className={styles.background}>
        <h1 className='page-header-h1'>Commercial Charging.</h1>
      </PageHeader>

      <div className={`${styles.commercialChargingPage} page-holder`}>
        <TextSection 
          header="It’s important to have the right chargers to suit your commercial setting"
          text="Nevo Advisory offers the complete EV charging solution for all sizes of commercial sites in Ireland. We have the best hardware, software and cloud services along with our excellent client success team to help you deliver a world-class service to your customers or employees."
        />

        <CommercialCharges />

        <div className={styles.formHolder}>
          <Form header='Get Started' />
        </div>

        <NevoBanner />
      </div>

      <Footer />
    </>
  )
};
